import { api } from '@/fsd/shared/api';
import { IClosureMonth } from '../../model/types/IClosureMonth';
import { IClosureMonthStatus } from '../../model/types/IClosureMonthStatus';

interface IParams {
  status?: IClosureMonthStatus[];
  year?: number;
  month?: number;
  ordering: string;
}

export const getAllClosureMonths = async (
  params: IParams
): Promise<IClosureMonth[] | undefined> => {
  try {
    let route = '/api/v1/monthly_closure/all/month/lock/';

    if (params) route = route + '?' + params.toString();

    const data = await api.get(route);

    if (!data || !Array.isArray(data)) {
      console.error('Непредвиденный формат ответа:', data);
      return;
    }

    return data;
  } catch (e) {
    console.error('Ошибка при получении месяцев закрытия:', e);
    return;
  }
};
